"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const hooks_1 = require("../../hooks");
const styled_components_1 = __importStar(require("styled-components"));
const device_1 = require("@completeanatomy/device");
const ui_1 = require("@completeanatomy/ui");
const selectors_1 = require("../../store/selectors");
function SystemStatus({ openedSystemId, defaultSubTitleStatus, }) {
    const systems = (0, hooks_1.useSelector)(selectors_1.getSystemStates);
    const { isMobile } = (0, device_1.usePlatform)();
    const [activeSystem, setActiveSystem] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (isMobile) {
            getActiveSystem();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openedSystemId, systems]);
    if (!isMobile) {
        return null;
    }
    const getActiveSystem = () => {
        const openedSystem = systems.find(system => system.identifier === openedSystemId);
        if (defaultSubTitleStatus) {
            if (defaultSubTitleStatus !== (openedSystem === null || openedSystem === void 0 ? void 0 : openedSystem.subtitle)) {
                return setActiveSystem(openedSystem || null);
            }
            return setActiveSystem(null);
        }
        return setActiveSystem(openedSystem || null);
    };
    return ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: !!activeSystem, appear: true, timeout: 200, mountOnEnter: true, unmountOnExit: true, "data-e2e": 'SystemStatus_CSSTransition', children: (0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'SystemStatus_Container', children: [(0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'SystemStatus_Title', children: activeSystem ? activeSystem.title : '' }), (0, jsx_runtime_1.jsx)(Status, { "data-e2e": 'SystemStatus_Status', children: activeSystem ? activeSystem.subtitle : '' })] }) }));
}
exports.default = SystemStatus;
const Container = styled_components_1.default.div `
  position: absolute;
  bottom: 200px;
  padding-left: 20px;
  transition: opacity 0.2s ease-in-out;

  ${ui_1.deviceLandscape.all((0, styled_components_1.css) `
    padding-left: env(safe-area-inset-left);
  `)}

  &.enter, &.appear {
    opacity: 0;
  }
  &.enter-active,
  &.appear-active {
    opacity: 1;
  }
  &.exit {
    opacity: 0;
  }
  &.exit-active {
    opacity: 0;
  }
`;
const Title = styled_components_1.default.div `
  color: ${({ theme }) => theme.text};
  font-size: 32px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.4);
`;
const Status = styled_components_1.default.div `
  color: ${({ theme }) => theme.text};
  font-weight: 600;
  font-size: 46px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.4);
`;
